import { render } from "./PurchaseReceive.vue?vue&type=template&id=6c3d18aa&scoped=true"
import script from "./PurchaseReceive.vue?vue&type=script&lang=js"
export * from "./PurchaseReceive.vue?vue&type=script&lang=js"

import "./PurchaseReceive.vue?vue&type=style&index=0&id=6c3d18aa&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3d18aa"]])

export default __exports__